import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index";
import CRUDroles from "./CRUDroles";
import CRUDcategorias from "./CRUDcategorias";
import CRUDevaluacion from "./CRUDevaluacion";
import Usuarios from "./Usuarios";
import Menu2Nivel from "./Menu2Nivel";
import Funcionalidad from "./Funcionalidad";
import roles from "./img/roles.png";
import usuarios from "./img/usuarios.png";
import grupo from "./img/grupo.png";
import evaluacion from "./img/evaluacion.png";
import { clBasic } from "./general";

export default function Administracion() {
  let { usrLogged } = useContext(AppContext);
  const [funcion, setFuncion] = useState("Usuarios");

  useEffect(() => {
    document.getElementById("htmlTituloPag").innerHTML = "Administración - " + funcion;
    document.getElementById("htmlTituloPagS").innerHTML = "";
  }, [funcion]);

  if (usrLogged.isLogged)
    return (
      <>
        {usrLogged.permisos.administracion ? (
          <div style={SAdministracion}>
            <Menu2Nivel>
              <Funcionalidad setF={setFuncion} filtroIcon={roles} funcion={"Roles"} />
              <Funcionalidad setF={setFuncion} filtroIcon={evaluacion} funcion={"Evaluación"} />
              <Funcionalidad setF={setFuncion} filtroIcon={grupo} funcion={"Categorias"} />
              <Funcionalidad setF={setFuncion} filtroIcon={usuarios} funcion={"Usuarios"} />
            </Menu2Nivel>
            {funcion === "Usuarios" && <Usuarios />}
            {funcion === "Roles" && <CRUDroles />}
            {funcion === "Categorias" && <CRUDcategorias />}
            {funcion === "Evaluación" && <CRUDevaluacion />}
          </div>
        ) : (
            <div style={{ color: clBasic }}>No tiene autorizadad para acceder a esta funcionalidad </div>
          )}
      </>
    );
  else return <div style={{ color: clBasic }}>Debe loguearse, gil!!</div>;
}

const SAdministracion = {
  overflow: "hidden",
  display: "flex",
  flexDirection: "row",
  height: "90vh",
};
